<script>
import store from '../Store/store'
import { CollapseTransition } from 'vue2-transitions'

export default {
  name: 'QuestionAnswer',

  components: {
    CollapseTransition
  },

  computed: {
    activeQuestionIndex() {
      return store.getters['questions/getActiveQuestionIndex']
    },
    isActive() {
      return store.getters['questions/isActiveQuestionIndex'](this.$attrs.questionindex)
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  &__answer {
    p {
      font-size: 14px;
      line-height: 1.5;
      padding-top: 5px;
    }
  }

  &__municipalities {
    font-size: 13px;
    padding-bottom: 10px;
  }
}
</style>
